import React, { useState } from 'react';
import { Highlight, useHits } from 'react-instantsearch';
import { useNavigate } from 'react-router-dom';
import { ModalFiche } from '../Recherche/ModalFiche';
import { useAuth } from '../../context/AuthContext';

function CustomHits({ editable = false }) {
    const { hits } = useHits();
    const [selectedHit, setSelectedHit] = useState(null);
    const navigate = useNavigate();
    const { user } = useAuth();

    // ✅ Droit de modifier CE résultat, en miroir de FicheVoter (backend) :
    // CELF toujours, GE seulement si le collège de la fiche fait partie de sa
    // session, Expert jamais. L'index Algolia ne porte que le libellé du
    // collège (pas son comId) : comparaison par libellé, moins robuste qu'une
    // comparaison par identifiant (cf. FichesAdd.js) mais c'est la seule
    // donnée disponible ici sans réindexer.
    const canEditHit = (hit) => {
        if (!editable) return false;
        if (user?.utcRole === "CE") return true;
        if (user?.utcRole === "GE") {
            const libelles = (user.commissions || []).map((c) => c.comLib);
            return libelles.includes(hit?.commission);
        }
        return false;
    };

    return (
        <>
            <div className="row">
                {hits.map((hit) => (
                    <div key={hit.objectID} className="col-md-3 mb-4">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body">
                                <h5 className="card-title">
                                    <Highlight attribute="terme_m" hit={hit} />
                                    <span>
                                        {hit.gramm_cat && `, ${hit.gramm_cat}`}
                                    </span>
                                </h5>
                                <div className="text-muted small">
                                    {hit?.date
                                        ? new Date(hit.date).toLocaleDateString('fr-FR')
                                        : ''}
                                </div>
                                <div><b>Commission :</b> {hit?.commission}</div>
                                <div><b>Domaine :</b> {hit?.domaine?.join("/")}</div>

                                <button
                                    className="btn btn-primary mt-2"
                                    onClick={() => setSelectedHit(hit)}
                                >
                                    Voir
                                </button>

                                {canEditHit(hit) && (
                                    <button
                                        className="btn btn-outline-primary mt-2 ms-2"
                                        onClick={() => navigate(`/creation_fiche/${hit.objectID}`)}
                                    >
                                        Éditer
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* ✅ Modale réutilisable partagée */}
            <ModalFiche hit={selectedHit} onClose={() => setSelectedHit(null)} />
        </>
    );
}

export default CustomHits;